<template>
  <a-form layout="vertical" class="form" ref="formRef" :model="formState">
    <h1>Completa la configuración inicial para tu plantilla</h1>
    <a-form-item label="Idioma de la plantilla" required>
      <a-select
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        v-model:value="formState.language"
        placeholder="Seleccionar idioma"
      >
        <a-select-option value="es">Español</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item required>
      <template #label>
        Categoría de la plantilla
        <a-tooltip>
          <template #title>
            <a
              href="https://www.securitec.pe/whatsapp-business-api/precios/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click aquí
            </a>
            para conocer más
          </template>

          <InfoCircleOutlined class="icon" />
        </a-tooltip>
      </template>

      <a-select
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        v-model:value="formState.category"
        placeholder="Seleccionar categoría"
        @change="handleChangeCategory"
      >
        <a-select-option
          v-for="template in templateCategoriesOptions.filter((opt) => opt.value)"
          :key="template.value"
          :value="template.value"
        >
          <a-popover
            :title="template.label"
            trigger="hover"
            placement="right"
            overlayClassName="template-category-popover"
          >
            <template #content>
              <div class="popover-content">
                {{ template.info }}
              </div>
            </template>

            <div style="width: 100%">{{ template.label }}</div>
          </a-popover>
        </a-select-option>
      </a-select>

      <p class="info" v-if="formState.category === WhatsappTemplateCategories.OTP">
        {{ infoText }}
      </p>
    </a-form-item>

    <a-form-item label="Tipo de plantilla" required>
      <a-select
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        v-model:value="formState.type"
        :options="templateTypeCategoriesOptions"
        placeholder="Seleccionar tipo de plantilla"
        @change="handleTypeChange"
        :disabled="formState.category === WhatsappTemplateCategories.OTP"
      />
    </a-form-item>

    <a-form-item label="Opción de botones" required>
      <a-select
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        v-model:value="formState.button"
        :options="templateButtonOptions"
        :placeholder="buttonText"
        :disabled="formState.category === WhatsappTemplateCategories.OTP"
      />
    </a-form-item>
  </a-form>
</template>

<script>
import { defineComponent, reactive, ref, watch, inject, nextTick } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

import {
  templateCategoriesOptions,
  templateTypeCategoriesOptions,
  templateButtonOptions,
} from "@/app/channels/utils/selectOptions";
import {
  WhatsappTemplateCategories,
  WhatsappTemplateButtons,
  WhatsappTemplateTypes,
} from "@/app/channels/utils/enums.js";

const infoText = "El contenido preestablecido es: “Tu código de verificación es {{1}}”";

export default defineComponent({
  components: {
    InfoCircleOutlined,
  },
  setup(props, { emit, expose }) {
    const formRef = ref(null);
    const buttonText = ref("Seleccionar botón");

    const templateType = inject("templateType");
    const templateButton = inject("templateButton");
    const steps = inject("steps");

    const formState = reactive({
      language: null,
      category: null,
      type: null,
      button: null,
    });

    const handleTypeChange = () => {
      templateType.value = formState.type;
      emit("clear-content");
      nextTick(() => {
        emit("active-button");
      });
    };

    const removeButtonStep = () => {
      for (let i = steps.length - 1; i >= 0; i--) {
        if (steps[i].includes("Botones")) {
          steps.splice(i, 1);
        }
      }
    };

    watch(
      () => formState.button,
      () => {
        templateButton.value = formState.button;
        console.log(formState);
        if (formState.button === WhatsappTemplateButtons.WithButton) {
          console.log(formState.button);
          const shouldAddButtonsStep =
            !steps.includes("Botones") && formState.category !== WhatsappTemplateCategories.OTP;

          if (shouldAddButtonsStep) steps.push("Botones");
        } else {
          removeButtonStep();
        }
      }
    );
    const valid = ref(false);
    watch(formState, () => {
      if (formState.language && formState.category && formState.type && formState.button){
        valid.value = true;
        return emit("active-button");
      };
      valid.value = false;
      return emit("inactive-button");
    });

    // watchEffect(() => {
    //   if (formState.category === WhatsappTemplateCategories.OTP) {
    //     buttonText.value = "Sin botón";
    //     formState.button = "WITHOUT_BUTTON";
    //     removeButtonStep();
    //   }
    // });

    const handleChangeCategory = () => {
      if (formState.category === WhatsappTemplateCategories.OTP) {
        formState.button = WhatsappTemplateButtons.WithButton;
        formState.type = WhatsappTemplateTypes.Text;

        const contentStepIndex = steps.findIndex((s) => s === "Contenido");
        steps.splice(contentStepIndex, 1);
        handleTypeChange();
      } else {
        formState.button = null;
        formState.type = null;

        const hasContentStep = steps.includes("Contenido");
        if (!hasContentStep) {
          const currentStepIndex = steps.findIndex((s) => s === "Configuración");
          steps.splice(currentStepIndex + 1, 0, "Contenido");
        }
      }
    };

    expose({ formState, valid });

    return {
      infoText,
      templateCategoriesOptions,
      templateTypeCategoriesOptions,
      templateButtonOptions,
      formRef,
      formState,
      buttonText,
      handleTypeChange,
      handleChangeCategory,
      WhatsappTemplateCategories,
    };
  },
});
</script>

<style lang="sass" scoped>
.icon
  margin-left: 4px

.form
  color: $gray-9

h3
  font-size: 16px
  font-weight: 600

p
  color: $gray-8

small
  font-size: 14px
  color: $gray-7

.popover-content
  width: 250px
  color: $gray-9

.info
  color: #00000073
  margin: 0
  margin-top: 2px

:global(.template-category-popover)
  padding-left: 25px
</style>
